<template>
  <section class="branch-info card">
    <h3 class="title">{{ $t('branch_desc') }}</h3>
    <collapsible-article class="text-article my-4" :expand-btn-text="$t('all_show_all')">
      <div class="whitespace-pre-wrap" v-html="props.product?.branch_intro"></div>
    </collapsible-article>
    <template v-if="props.product?.facilities?.length">
      <hr class="my-4" />
      <h3 class="title">{{ $t('product_special_facilities') }}</h3>
      <div class="facilities flex md:grid md:grid-cols-3 -mx-5">
        <template v-for="facility in displayedFacilities" :key="facility.id">
          <div class="facility flex items-center gap-5 p-5">
            <nd-img :src="`fn:${facility.icon}`" :alt="facility.name" class="w-8 h-8" />
            <span v-if="!isSmallScreen">{{ facility.name }}</span>
          </div>
        </template>
        <content-viewer v-if="isDisplayShowAllBtn" :title="$t('product_special_facilities')" modal-class="w-640px">
          <template #trigger="{ open }">
            <div class="show-more flex items-center gap-5 p-5 text-yellow-50 cursor-pointer" @click="open()">
              <svg-icon name="more" class="w-8 h-8" />
              <span v-if="!isSmallScreen">{{ $t('all_show_all') }}</span>
            </div>
          </template>
          <template #default>
            <div class="facilities flex flex-wrap flex-col md:flex-row -mx-5">
              <template v-for="facility in props.product.facilities" :key="facility.id">
                <div class="facility min-w-200px flex-1 flex items-center gap-2 py-3 px-5 md:gap-5 md:py-5">
                  <nd-img :src="`fn:${facility.icon}`" :alt="facility.name" class="w-8 h-8" />
                  <span>{{ facility.name }}</span>
                </div>
              </template>
            </div>
          </template>
        </content-viewer>
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
import { useAppStore } from '@/store/app'

import CollapsibleArticle from '@/components/common/collapsible-article.vue'
import ContentViewer from '@/components/common/content-viewer.vue'

import type { UiProductInfo } from '@/types/product'

const app = useAppStore()

const props = defineProps<{
  product: UiProductInfo
}>()

const isSmallScreen = computed(() => app.isMobile || app.isTablet)

const limit = computed(() => (isSmallScreen.value ? 2 : 8))
const isDisplayShowAllBtn = computed(() => props.product?.facilities && props.product?.facilities.length > limit.value)
const displayedFacilities = computed(() => {
  if (!props.product?.facilities) return []

  return props.product.facilities.slice(0, limit.value)
})
</script>

<style lang="scss" scoped></style>
